<div class="dashboard">
  <mat-grid-list [cols]="columnNum" rowHeight="10rem" [gutterSize]="'1rem'">
    <mat-grid-tile *ngFor="let card of cards | async" [colspan]="card.cols" [rowspan]="card.rows">
      <mat-card [routerLink]="card.routerLink" matRipple>
        <mat-card-header>
          <mat-icon aria-hidden="false" color="primary">{{ card.icon }}</mat-icon>
        </mat-card-header>
        <mat-card-content>
          <mat-card-title>
            {{ card.title | translate }}
          </mat-card-title>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
